import { render, staticRenderFns } from "./movimento.vue?vue&type=template&id=b3203e8e&"
import script from "./movimento.vue?vue&type=script&lang=js&"
export * from "./movimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports